import gsap from 'gsap';

export default class CollectionSubnav extends HTMLElement {
  private scrollContent: HTMLDivElement | null = null;
  private gradientLeft: HTMLDivElement | null = null;
  private gradientRight: HTMLDivElement | null = null;

  private leftGradientIsVisible = false;
  private rightGradientIsVisible = false;

  private onScrollBound = this.onScroll.bind(this);
  private onResizeBound = this.onResize.bind(this);

  connectedCallback(): void {
    this.scrollContent = this.querySelector('[data-collection-subnav-ref="scroll-content"]');
    this.gradientLeft = this.querySelector('[data-collection-subnav-ref="gradient-left"]');
    this.gradientRight = this.querySelector('[data-collection-subnav-ref="gradient-right"]');

    this.addEventListeners();
    this.updateGradients();
  }

  addEventListeners(): void {
    this.scrollContent?.addEventListener('scroll', this.onScrollBound, { passive: true });
    window.addEventListener('resize', this.onResizeBound);
  }

  removeEventListeners(): void {
    this.scrollContent?.removeEventListener('scroll', this.onScrollBound);
    window.removeEventListener('resize', this.onResizeBound);
  }

  onScroll(): void {
    this.updateGradients();
  }

  onResize(): void {
    this.updateGradients();
  }

  updateGradients(): void {
    if (!this.scrollContent || !this.gradientLeft || !this.gradientRight) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContent;
    const shouldShowLeft = scrollLeft > 0;
    const shouldShowRight = scrollLeft < scrollWidth - clientWidth - 1;

    if (shouldShowLeft !== this.leftGradientIsVisible) {
      this.leftGradientIsVisible = shouldShowLeft;
      gsap.to(this.gradientLeft, {
        autoAlpha: shouldShowLeft ? 1 : 0,
        duration: 0.3,
        ease: 'power2.out',
      });
    }

    if (shouldShowRight !== this.rightGradientIsVisible) {
      this.rightGradientIsVisible = shouldShowRight;
      gsap.to(this.gradientRight, {
        autoAlpha: shouldShowRight ? 1 : 0,
        duration: 0.3,
        ease: 'power2.out',
      });
    }
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('collection-subnav', CollectionSubnav);
